import { config } from "../../../config"
import React, { useState } from "react";
import { Button, Row, Col } from "reactstrap";

import PosSearch from "./pos/PosSearch";
import PosList from "./pos/PosList";
// import { useHistory } from "react-router-dom/cjs/react-router-dom";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

import Datetime from "react-datetime";
import "react-datetime/css/react-datetime.css";

import moment from 'moment-timezone';

const PointOfSales = () => {

    const [minCheckedAt, setMinCheckedAt] = useState(null)
    const [maxCheckedAt, setMaxCheckedAt] = useState(null)
    const roleName = useSelector((state) => state.identityReducer?.identity?.role?.label?.toUpperCase() )
    const token = useSelector((state) => state.identityReducer.token )
    const navigate = useNavigate()

    const onNewPosClick = () => {
        // history.push("/pos")
        navigate('/pos')
    };

    const formatDate = (dateString) => {
        let desiredFormat = "DD/MM/YYYY";
        let timeToBeConverted = moment(dateString);
        let timeZone = "Europe/Rome";

        return dateString ? timeToBeConverted.tz(timeZone).format(desiredFormat) : null;
    }

    return (
        <div className="app-drawer">
            <div className="bg-white app-drawer-content">
                <Row className="pt-4 px-4 pb-1">
                    {
                        (roleName === 'SUPERADMIN' || roleName === 'ADMIN')
                        ? <>
                            <Col md="8" className="text-left">
                                <div>
                                    <b>Ricerca testuale</b>
                                    <PosSearch />
                                </div>
                            </Col>
                            <Col md="4">
                                <div className="float-end">
                                    <br/>
                                    <Button id="new_pos_btn" color="primary" style={{whiteSpace: "nowrap"}} onClick={onNewPosClick} >
                                        <span className="fas fa-check"></span> NUOVO PdV
                                    </Button>
                                    <Button 
                                        id="download_btn" 
                                        href={config.baseurl + "/export/pos.csv?apikey="+config.apiKey+"&token="+token.signature}
                                        tag="a"
                                        color="secondary" 
                                        style={{marginLeft: "5px"}} 
                                    >
                                        <span className="fas fa-download"></span>
                                    </Button>
                                </div>
                            </Col>
                        </>
                        : <>
                            <Col md="12" className="text-left">
                                <div>
                                    <b>Ricerca testuale</b>
                                    <PosSearch />
                                </div>
                            </Col>
                        </>
                    }
                </Row>
                <Row className="pt-1 px-4 pb-4">
                    <Col md="3">
                        <div>
                            <b>Data inizio conteggi</b>
                            <Datetime
                                dateFormat="DD/MM/YYYY"
                                timeFormat={false}
                                value={formatDate(minCheckedAt)}
                                inputProps={{ placeholder: "seleziona una data..." }}
                                onChange={(value) => {
                                    setMinCheckedAt(value ? value.toISOString() : null)
                                }}
                            />
                        </div>
                    </Col>
                    <Col md="3">
                        <div>
                            <b>Data fine conteggi</b>
                            <Datetime
                                dateFormat="DD/MM/YYYY"
                                timeFormat={false}
                                value={formatDate(maxCheckedAt)}
                                inputProps={{ placeholder: "seleziona una data..." }}
                                onChange={(value) => {
                                    setMaxCheckedAt(value ? value.toISOString() : null)
                                }}
                            />
                        </div>
                    </Col>
                    <Col md="6" className="font-12 mt-1 text-muted">
                        <br/>
                        <i>
                            Le date selezionatte determinano i conteggi <br/>
                            di numero <b>Check</b> e <b>Punteggio (Pt.)</b>
                        </i>
                    </Col>
                </Row>
                <div style={{height: 'calc(100vh - 350px)'}}>
                    <PosList minCheckedAt={minCheckedAt} maxCheckedAt={maxCheckedAt} />
                </div>
            </div>
        </div>
    );
};

export default PointOfSales;